import { useDispatch, useSelector } from "react-redux";
import Routes from "../../app/routes";
import AppLayouts from "./AppLayouts";

const AppLayout = () => {
  const horizontalNavPosition = useSelector(
    ({ settings }) => settings.horizontalNavPosition
  );
  const navigationStyle = useSelector(
    ({ settings }) => settings.navigationStyle
  );
  const onGetLayout = (layout) => {
    switch (layout) {
      case "inside_the_header":
        return "InsideHeaderNav";

      case "above_the_header":
        return "AboveHeaderNav";

      case "below_the_header":
        return "BelowHeaderNav";
      default:
        return "Horizontal";
    }
  };

  const Layout =
    AppLayouts[
      navigationStyle === "vertical_navigation"
        ? "Horizontal"
        : onGetLayout(horizontalNavPosition)
    ];
  return (
    <Layout>
      <Routes />
    </Layout>
  );
};

export default AppLayout;
